import type { ApiDashboardElement } from '@highimpact-frontend/api-types';
import type { DecimationPolicy } from '@highimpact/react-hooks';
import type { ThresholdRequestContextPrefs } from '@highimpact/scatterplot';

import type { DashboardScope } from '../../../../state/dashboardRuntimeTypes';
import {
  useElementMeasureTransport,
  type ElementMeasurePlotType,
} from '../shared/useElementMeasureTransport';

export interface UsePlotMeasureTransportOptions {
  readonly element: ApiDashboardElement;
  readonly plotType: 'timeseries' | 'scatter';
  readonly thresholdRequest?: ThresholdRequestContextPrefs;
  readonly scope?: DashboardScope;
  readonly decimationPolicy?: DecimationPolicy;
}

/**
 * Session-cache measure transport derived from dashboard element JSON.
 *
 * @deprecated Use {@link useElementMeasureTransport} directly.
 */
export function usePlotMeasureTransport({
  element,
  plotType,
  thresholdRequest,
  scope,
  decimationPolicy,
}: UsePlotMeasureTransportOptions) {
  const {
    transport,
    measureRequestSignature,
    usesElementMeasureRequest,
  } = useElementMeasureTransport({
    element,
    plotType: plotType as ElementMeasurePlotType,
    thresholdRequest,
    scope,
    decimationPolicy,
  });

  return {
    transport,
    measureRequestSignature,
    usesElementMeasureRequest,
  };
}
